export default "__VITE_ASSET__CaMv$7bN__"